import React, { useEffect, useState } from 'react'
import { Button, Modal, TextField } from '@mui/material'
import Swal from 'sweetalert2'
import request from '../../../Helpers/API'
import { LoaderScreen } from '../../components/LoaderScreen'

// Modal de Alta/Edición del catálogo de Líneas del Scorecard.
// idlinea === ID_LINEA_NUEVA  -> alta (formulario limpio, sin consultar API)
// idlinea > 0                 -> edición (se consulta BuscarID)
const ID_LINEA_NUEVA = -999;
const LONGITUD_MAXIMA_DESCRIPCION = 100;
const TITULO = "LINEAS SCORECARD";
const LINEA_INICIAL = { descripcion: "", estatus: 1 };
const LOADER_INICIAL = { mostrar: false, alerta: false, error: false, mensaje: "" };

const ModalAgregarLineasScorecard = ({ open, handleCloseModal, idlinea }) => {
    // Sólo es edición cuando llega un id real; -999 (o 0 en el primer render) es alta.
    const esEdicion = Number(idlinea) > 0;

    const [linea, setLinea] = useState(LINEA_INICIAL);
    const [loader, setLoader] = useState(LOADER_INICIAL);

    useEffect(() => {
        // El modal cerrado no debe consultar la API: con idlinea = 0 el endpoint
        // responde con cuerpo vacío y request.get truena al hacer result.json()
        // ("Unexpected end of JSON input").
        if (!open) return;

        if (!esEdicion) {
            setLinea(LINEA_INICIAL);
            return;
        }

        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .get(`LineasScorecard/BuscarID?idlinea=${idlinea}`)
            .then((result) => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                setLinea({
                    descripcion: result?.descripcion ?? "",
                    estatus: result?.estatus ?? 1,
                });
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire(
                    TITULO,
                    "No fue posible cargar la información de la línea. Intente nuevamente o contacte al administrador.",
                    "error"
                );
            });
    }, [open, idlinea, esEdicion]);

    const onGuardar = () => {
        // Validación en frontend; el backend debe validar de nuevo con Data Annotations.
        const descripcion = linea.descripcion.trim();

        if (!descripcion) {
            Swal.fire(TITULO, "Indique el nombre de la línea.", "warning");
            return;
        }

        if (descripcion.length > LONGITUD_MAXIMA_DESCRIPCION) {
            Swal.fire(
                TITULO,
                `El nombre de la línea no puede exceder ${LONGITUD_MAXIMA_DESCRIPCION} caracteres.`,
                "warning"
            );
            return;
        }

        const post = {
            idlinea: esEdicion ? idlinea : ID_LINEA_NUEVA,
            descripcion: descripcion,
            estatus: linea.estatus,
        };

        setLoader((prev) => ({ ...prev, mostrar: true }));
        request
            .post("LineasScorecard", post)
            .then(async () => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                await Swal.fire(TITULO, "Registro guardado con éxito.", "success");
                onCerrar();
            })
            .catch(() => {
                setLoader((prev) => ({ ...prev, mostrar: false }));
                Swal.fire(
                    TITULO,
                    "No fue posible guardar el registro. Intente nuevamente o contacte al administrador.",
                    "error"
                );
            });
    };

    // Limpia el formulario antes de cerrar para que el siguiente alta abra vacío.
    const onCerrar = () => {
        setLinea(LINEA_INICIAL);
        handleCloseModal?.();
    };

    return (
        <Modal open={open} onClose={onCerrar}>
            <div className="lineas-scorecard-modal-agregar-main-screen">
                <LoaderScreen loader={loader} />

                {/* <div className="lineas-scorecard-modal-titulo">
                    {esEdicion ? "EDITAR LÍNEA" : "AGREGAR LÍNEA"}
                </div> */}

                <div className="lineas-scorecard-modal-campo">
                    <TextField
                        id="lineas-scorecard-descripcion"
                        label="Linea"
                        type="text"
                        fullWidth
                        // required
                        value={linea.descripcion}
                        inputProps={{ maxLength: LONGITUD_MAXIMA_DESCRIPCION }}
                        onChange={({ target }) =>
                            setLinea((prev) => ({ ...prev, descripcion: target.value }))
                        }
                    />
                </div>

                <div className="lineas-scorecard-modal-button-container">
                    <Button variant="contained" onClick={onCerrar}>
                        CERRAR
                    </Button>
                    <Button variant="contained" onClick={onGuardar}>
                        {esEdicion ? "GUARDAR" : "AGREGAR"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default ModalAgregarLineasScorecard;
